import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Hidden from "@insite/mobius/Hidden";
import { IconPresentationProps, IconWrapper } from "@insite/mobius/Icon";
import Branch from "@NA/Icons/Branch";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import React, { FC, useState } from "react";
import { ResolveThunks, connect, useSelector } from "react-redux";
import { css } from "styled-components";
import toggleLoginDrawer from "@NA/Handlers/ADILoginDrawerHandler";
import Drawer from "@insite/mobius/Drawer";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Rewards from "@NA/Icons/RewardsIcon";
import {LoyaltyRewards} from "@NA/Widgets/LoyaltyRewards/LoyaltyRewardsView";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import { checkVaildUserForHmiRewards, fomratLoyaltyPoints } from "@NA/Utils/Utility";
import toggleRewardsDrawer from "@NA/Handlers/ADIRewardsDrawerHandler";
import setNavDrawerIsOpen from "@insite/client-framework/Store/Components/AddressDrawer/Handlers/SetNavDrawerIsOpen";
import { LoyaltyRewardsUser } from "./LoyaltyRewards/LoyaltyRewardsUserView";

const enum fields {
    visibilityState = "visibilityState",
    icon = "icon",
}

const mapStateToProps = (state: ApplicationState) => {
    const billToId = state.context.session.billToId;
    let acNoSession;
    if (billToId) {
        acNoSession = state.data.billTos.byId[billToId]?.customerNumber
    }
    return {
        session: state.context.session,
        acNoSession,
    };
};

const mapDispatchToProps = {
    toggleLoginDrawer,
    toggleRewardsDrawer,
    setNavDrawerIsOpen
};

export interface BranchLinkStyles {
    routerLink?: LinkPresentationProps;
    desktopCountText?: TypographyPresentationProps;
    mobileCountText?: TypographyPresentationProps;
    compactCountText?: TypographyPresentationProps;
    branchText?: TypographyPresentationProps;
}

export const branchLinkStyles: BranchLinkStyles = {
    routerLink: {
        typographyProps: {
            variant: "headerSecondary",
        },
        icon: {
            iconProps: {
                size: 30,
                css: css`
                    height: 28px;
                    width: auto;
                    position: relative;
                    top: 0px;
                    ${({ theme }) => {
                        return breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    top: 1px;
                                `,
                                null,
                                css`
                                    top: 1px;
                                `,
                            ],
                            "max",
                        );
                    }}
                `,
            },
        },
        color: "secondary",
        css: css`
            padding: 0px;
            position: relative;
            //display: block !important;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 0px;
            flex-direction: column;
            ${IconWrapper} {
                margin-right: 0px;
            }
            ${TypographyStyle} {
                color: #002856;
                font-size: 10px;
                font-weight: 400;
                line-height: normal;
                text-transform: lowercase;
                white-space: nowrap;
                position: relative;
                top: 0px;
            }
        `,
    },

    compactCountText: {
        css: css`
            font-weight: normal;
        `,
    },
    mobileCountText: {
        css: css`
            background: ${getColor("primary")};
            width: 15px;
            height: 15px;
            display: block;
            border-radius: 11px;
            color: ${getColor("primary.contrast")};
            text-align: center;
            font-size: 10px;
            position: absolute;
            left: 18px;
            top: -8px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            right: 2px;
                        `,
                        css`
                            right: 2px;
                        `,
                        css`
                            right: 2px;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    branchText: {
        css: css`
            /* font-family: "sans-serif"; */
            font-size: 0.875rem;
            text-transform: capitalize;
            color: ${getColor("secondary")};
        `,
    },
};

const iconMap = {
    rewards: Rewards,
    none: undefined,
} as const;

interface OwnProps extends WidgetProps {
    fields: {
        [fields.visibilityState]: "both" | "label" | "icon";
        [fields.icon]: keyof typeof iconMap;
    };
    isCompactHeaderCart?: boolean;
    theme: BaseTheme;
}

const signInDrawer: any = {
    position: "right",
    size: 350,

    closeButtonProps: {
        shape: "pill",
        buttonType: "solid",
        color: "common.background",
        size: 36,
        css: css`
            padding: 0px;
            border-radius: 0;
            background: transparent;
            border: none;
        `,
        hoverStyle: {
            background: "transparent",
            borderColor: "transparent",
        },
        activeStyle: {
            background: "transparent",
            borderColor: "transparent",
        },
    },
    cssOverrides: {
        scrim: css`
            top: 116px;
            ${({ theme }) => { return breakpointMediaQueries(
                theme, [css` top: 0px;`, css` top: 0px;`, css` top: 86px;`,],); 
            }}
        `,
        drawerTitle: css`
            background: ${getColor("common.background")};
            position: absolute;
            align-self: flex-end;
            justify-content: center;
            margin: 0px;
            padding: 0px;
            width: 16px;
            height: 16px;
            min-height: 16px;
            top: 20px;
            right: 20px;
            z-index: 999;
        `,
        drawerContent: css`
            &::-webkit-scrollbar {
                width: 4px;
            }

            &::-webkit-scrollbar-track {
                background: ${getColor("common.background")};
            }

            &::-webkit-scrollbar-thumb {
                background-color: ${getColor("common.border")};
                border-radius: 7px;
            }
        `,
        drawerBody: css`
            overflow: hidden auto;
            max-height: calc(100vh - 88px);
            top: 115px;
            width: 375px;
            height: 100%;
            border-radius: 0;
            padding-top: 15px;
            padding-right: 0px;
            padding-bottom: 15px;
            cursor: default;
            margin: 0px;
            margin-top: -0.1px;
            background: ${getColor("common.background")};
            transform-origin: 100% 50%;
            animation: menuanimation 1s;
            box-shadow: inset -2px 5px 4px -4px rgba(0, 0, 0, 0.28);
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            max-height: 100%;
                            top: 0px;
                            box-shadow: none;
                            width: 100%;
                        `,
                        css`
                            top: 86px;
                        `,
                    ],
                    "max",
                );
            }}

            ${({ theme }) => { return breakpointMediaQueries(
                theme, [null, css` top: 0px; `,],"max",); 
            }}

            @keyframes menuanimation {
                0% {
                    right: -374px;
                }
                100% {
                    right: 0px;
                }
            }
        `,
    },

    headlineTypographyProps: {
        color: "text.main",
    },
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const styles = branchLinkStyles;
const ADILoyalityRewards: FC<Props> = ({
    session,
    acNoSession,
    fields: { visibilityState, icon: selectedIcon },
    toggleLoginDrawer,
    toggleRewardsDrawer,
    setNavDrawerIsOpen
}) => {
    const isAuthenticated = session && (session.isAuthenticated || session.rememberMe) && !session.isGuest;
    const loyaltyState = useSelector((state: CustomApplicationState) => state.ADIGlobalData?.loyaltyRewardStore);
    const userRoles = useSelector((state: CustomApplicationState) => state.context.session.userRoles);
    const loginDrawerState = useSelector((state: CustomApplicationState) => state.ADIGlobalData.loginDrawerStore);
    const isProRewardsUser = userRoles && userRoles.includes("ADIProRewards");
    const rewardDrawerState = useSelector((state: CustomApplicationState) => state.ADIGlobalData?.rewardsDrawerStore);
    
    const accNoSession= acNoSession?.toString().split('-')[0];
    const userloyaltyState = useSelector((state: CustomApplicationState) => state.ADIGlobalData?.loyaltyRewardUserStore);
    const accNoLTY=userloyaltyState.user.userId!= undefined ? userloyaltyState.user.userId: ""
    const userNameSession= useSelector((state:CustomApplicationState) => state.context.session.userName?.toLocaleLowerCase());
    const emailLTY= userloyaltyState.user.email!= undefined ? userloyaltyState.user.email?.toLocaleLowerCase() : ""
    const showRewardsIcon=(accNoLTY==accNoSession && userloyaltyState.user.isEnrolled==false && userNameSession==emailLTY && !isProRewardsUser &&
            (userloyaltyState.user.status?.toLocaleUpperCase()=="A" || 
            userloyaltyState.user.status?.toLocaleUpperCase()=="B" ||
            userloyaltyState.user.status?.toLocaleUpperCase()=="O"));

    const showIcon = visibilityState !== "both";
    const showLabel = visibilityState !== "both";
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const icon = iconMap[(showIcon && selectedIcon) || "none"] as IconPresentationProps["src"];

    const { routerLink } = styles;

    const closeModal = () => {
        setIsDrawerOpen(false);
        toggleRewardsDrawer({ rewardsDrawer: false });
    };
    const openModal = () => {
        if (loginDrawerState.loginDrawer) {
            toggleLoginDrawer({ loginDrawer: false });
        }
        setIsDrawerOpen(true);
        toggleRewardsDrawer({ rewardsDrawer: true });
        setNavDrawerIsOpen({ navDrawerIsOpen: false });
    };
    const cssBorderStyle = {
        css: css`
            border-bottom: ${rewardDrawerState.rewardsDrawer && "4px solid #002856"};
            padding-top: ${rewardDrawerState.rewardsDrawer && "7px"};
            padding-bottom: ${rewardDrawerState.rewardsDrawer && "4px"};
        `,
    };

    return (
        <>
            {!loyaltyState.isLoading &&
                isAuthenticated &&
                isProRewardsUser &&
                loyaltyState &&
                checkVaildUserForHmiRewards(loyaltyState.loyalty) && (
                    <>
                        <Link
                            {...routerLink}
                            onClick={() => openModal()}
                            icon={{ ...routerLink?.icon, iconProps: { src: icon, ...routerLink?.icon?.iconProps } }}
                            data-test-selector="rewardsLink"
                        >
                            <Hidden below="lg" as="span" {...cssBorderStyle}>
                                {showLabel &&
                                    loyaltyState &&
                                    loyaltyState.loyalty &&
                                    fomratLoyaltyPoints(loyaltyState.loyalty?.balance, "")}
                                {translate(" pts")}
                            </Hidden>
                        </Link>
                        <Drawer
                            isOpen={rewardDrawerState.rewardsDrawer}
                            {...signInDrawer}
                            handleClose={() => closeModal()}
                            data-test-selector="rewardsDrawer"
                        >
                            <StyledWrapper className="ADIModal">
                                <LoyaltyRewards loyaltyModel={false} closePopup={closeModal} />
                            </StyledWrapper>
                        </Drawer>
                    </>
                )}
                {!userloyaltyState.isLoading &&
                isAuthenticated &&
                showRewardsIcon &&
                userloyaltyState.user && (
                    <>
                        <Link
                            {...routerLink}
                            onClick={() => openModal()}
                            icon={{ ...routerLink?.icon, iconProps: { src: icon, ...routerLink?.icon?.iconProps } }}
                            data-test-selector="rewardsUserLink"
                        >
                            <Hidden below="lg" as="span" {...cssBorderStyle} style={{textTransform: "capitalize"}}>
                            {showLabel }
                                {translate("Rewards")}
                            </Hidden>
                        </Link>
                        <Drawer
                            isOpen={rewardDrawerState.rewardsDrawer}
                            {...signInDrawer}
                            handleClose={() => closeModal()}
                            data-test-selector="rewardsDrawer"
                        >
                            <StyledWrapper className="ADIModal">
                                <LoyaltyRewardsUser loyaltyModel={false} closePopup={closeModal} />
                            </StyledWrapper>
                        </Drawer>
                    </>
                )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ADILoyalityRewards),
    definition: {
        displayName: "ADI Loyality Rewards",
        icon: "rewards",
        fieldDefinitions: [
            {
                name: fields.visibilityState,
                displayName: "Settings",
                editorTemplate: "RadioButtonsField",
                options: [
                    {
                        displayName: "Show Both",
                        value: "both",
                    },
                    {
                        displayName: "Show Label Only",
                        value: "label",
                    },
                    {
                        displayName: "Show Icon Only",
                        value: "icon",
                    },
                ],
                defaultValue: "icon",
                fieldType: "General",
                sortOrder: 1,
            },
            {
                name: fields.icon,
                displayName: "Loyality Rewards Icon",
                editorTemplate: "DropDownField",
                options: [
                    {
                        displayName: "None",
                        value: "none",
                    },

                    {
                        displayName: "Loyality Rewards",
                        value: "rewards",
                    },
                ],
                defaultValue: "Loyality Rewards",
                fieldType: "General",
                sortOrder: 2,
            },
        ],
        group: "Common",
    },
};

export default widgetModule;
